
const ee = "EmploymentEquity";

export const GetEmployeeMovementHeadcountSummary = `${ee}/Movements/HeadcountSummary`;
export const GetIndividualEmployeeMovementInfo = `${ee}/Movements/Individuals`;

export const GetSkillsDevelopmentHeadcountSummary = `${ee}/SkillsDevelopment/HeadcountSummary`;
export const GetSkillsDevelopmentIndividualsInfo = `${ee}/SkillsDevelopment/Individuals`;

export const GetWorkforceProfileHeacountSummary = `${ee}/WorkforceProfile/WorkforceProfileHeadcountSummary`;

export const GetMonitoringAndEvaluationInfo = `${ee}/MonitoringAndEvaluation`;
export const SaveMonitoringAndEvaluationInfo = `${ee}/MonitoringAndEvaluation`;